// extracted by mini-css-extract-plugin
export default {"basic-history-list":"BasicHistoryList_basic-history-list__eqUE1","no-history":"BasicHistoryList_no-history__0kgQd"};